<template>
  <history-details-hero-page-resolver
    :route-name="routeName"
    :resolvers="resolvers"
  >
    <template v-slot:loader>
      <bulk-details-info-loading
        :title="$t('scheduledDetailsInfoLoading.title')"
        :description="$t('scheduledDetailsInfoLoading.description')"
      />
    </template>
  </history-details-hero-page-resolver>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, watch } from '@/composition/vue/compositionApi'

import { get, getScheduledService } from '@/core/container/ioc'
import TmLogicError from '@/core/error/tmLogicError'

import { useMainSidebarScheduledSMSSections } from '@/composition/mainSidebar/menu/useMainSidebarScheduledMenu'

import type BaseResolverService from '@/services/resolvers/baseResolverService'
import type { SingleModelResolverParams } from '@/services/resolvers/types'

import type { ResolverConfig, Resolvers } from '@/services/types'
import HistoryDetailsHeroPageResolver from '@/components/shared/bulkDetails/HistoryDetailsHeroPageResolver.vue'
import BulkDetailsInfoLoading from '@/components/shared/bulkDetails/BulkDetailsInfoLoading.vue'

const props = defineProps<{
  resolvers: Resolvers
  routeName: string
}>()

const scheduledService = getScheduledService()

const { onToggle } = useMainSidebarScheduledSMSSections()

const resolver = props.resolvers.filter((r): r is ResolverConfig<SingleModelResolverParams> => {
  if (Array.isArray(r)) {
    return false
  }
  return r.service === 'RedirectableSingleModelResolverService'
})[0]

if (!resolver?.params) {
  throw new TmLogicError('ScheduledSmsDetailsResolver: No resolver found')
}

const resolverService = get<BaseResolverService>('BaseResolverService')

const messageId = resolverService.getId(resolver.params)

const message = computed(() => scheduledService.findAnyTypeEntityById(messageId))

const status = computed(() => message.value?.status)

watch(
  status,
  (statusValue) => {
    if (statusValue) {
      onToggle(statusValue, true)
    }
  },
  { immediate: true },
)

onBeforeUnmount(() => {
  if (status.value) {
    onToggle(status.value, false)
  }
})
</script>
